import * as React from 'react';
import RcCollapse from 'rc-collapse';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider';
import devWarning from '../_util/devWarning';
const CollapsePanel = props => {
    if (process.env.NODE_ENV !== 'production')
        devWarning(!('disabled' in props), 'Collapse.Panel', '`disabled` is deprecated. Please use `collapsible="disabled"` instead.');
    const { getPrefixCls } = React.useContext(ConfigContext);
    const { prefixCls: customizePrefixCls, className = '', showArrow = true } = props;
    const prefixCls = getPrefixCls('collapse', customizePrefixCls);
    const collapsePanelClassName = classNames({
        [`${prefixCls}-no-arrow`]: !showArrow,
    }, className);
    return <RcCollapse.Panel {...props} prefixCls={prefixCls} className={collapsePanelClassName}/>;
};
export default CollapsePanel;
